import { definePlugin } from '../../code-plug';

import { ImportJSONSchemaMenuItem } from './views/import-json-schema-button';

definePlugin('builder-import-json-schema', ({ registerView }) => {

  registerView(
    'form-builder-toolbar',
    ImportJSONSchemaMenuItem,
    {
      parent: 'Form',
      group: 'import-export',
      key: 'form-builder-toolbar-json-schema'
    }
  );

});
